import { COMPONENT_TYPES } from '../../../constants';
import ProductSliderComponent from './ProductSlider.component';
import ProductSliderEditor from './ProductSlider.editor';
import ProductSliderProperties from './ProductSlider.properties';
import { registerComponent } from '../registry';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.PRODUCT_SLIDER, // constants.js에 정의된 타입 상수 사용
  component: ProductSliderComponent,
  editorComponent: ProductSliderEditor,
  properties: ProductSliderProperties,
  defaultProps: {
    // 기본 속성 정의
    componentProps: {
      sliderTitle: '인기 상품',
      showTitle: true,
      titleFontSize: '18px',
      titleFontWeight: '600',
      titleColor: '#333',
      itemsPerSlide: 4,
      autoSlide: true,
      autoSlideInterval: 3000,
      showStock: false
    },
    style: {
      backgroundColor: 'transparent',
      borderWidth: '1px',
      borderColor: '#eeeeee',
      borderRadius: '0px',
      boxShadow: 'none',
      padding: '0 15px',
      margin: '0'
    }
  },
  category: 'content', // 컴포넌트 카테고리
  icon: '🛒', // 대표 아이콘
  name: '상품 슬라이더' // 표시할 이름
});

// 컴포넌트 및 타입 내보내기
export { default as ProductSliderComponent } from './ProductSlider.component';
export { default as ProductSliderEditor } from './ProductSlider.editor';
export { default as ProductSliderProperties } from './ProductSlider.properties';
export * from './ProductSlider.types'; 